import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { Communication } from "../../models/communication.model";

@Injectable({
	providedIn: "root",
})
export class CommunicationsApiService {
	constructor(private http: HttpClient) {}

	getCommunicationsByPsId(psId: number): Observable<Communication[]> {
		return this.http.get<Communication[]>(`${environment.apiEmotion()}/communication/visible/${psId}`);
	}

	getCommunication(communicationId: number, ccommunicationMode: string): Observable<Communication> {
		return this.http.get<Communication>(
			`${environment.apiEmotion()}/communication/visible/${communicationId}/${ccommunicationMode}`,
		);
	}
}
